import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../components/dashboard/DashboardLayout";
import { PageHeader, StatusBadge } from "../../components/dashboard/UI";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { Download, MapPin } from "lucide-react";

const Projects = () => {
  const { t } = useI18n();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  return (
    <DashboardLayout>
      <PageHeader
        eyebrow={t("dashboard.summary")}
        title={t("dashboard.projects")}
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {projects.map((p) => (
          <article key={p.id} className="card-sharp p-6" data-testid={`project-${p.code}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-[10px] font-mono text-[#19A7E0] tracking-[0.2em]">{p.code}</p>
                <h3 className="mt-1.5 text-lg font-medium tracking-tight">{p.name}</h3>
                <p className="mt-2 text-xs font-mono uppercase tracking-[0.2em] text-white/50 flex items-center gap-1.5">
                  <MapPin className="w-3 h-3" /> {p.location} · {p.country}
                </p>
              </div>
              <StatusBadge status={p.status} label={t(`statuses.${p.status}`)} />
            </div>

            <div className="mt-5">
              <div className="flex items-center justify-between text-[11px] font-mono uppercase tracking-[0.18em] mb-1.5">
                <span className="text-white/50">{p.technology}</span>
                <span className="text-[#19A7E0]">{p.completion_percent}%</span>
              </div>
              <div className="h-1 bg-white/[0.06] rounded-sm overflow-hidden">
                <div
                  className="h-full bg-[#19A7E0]"
                  style={{ width: `${p.completion_percent}%` }}
                />
              </div>
            </div>

            <ul className="mt-5 space-y-2.5">
              {p.milestones.map((m, i) => (
                <li key={i} className="flex items-center gap-3 text-xs">
                  <span
                    className={`status-dot ${
                      m.status === "completed" ? "dot-success" :
                      m.status === "in_progress" ? "dot-accent" : "dot-muted"
                    }`}
                  />
                  <span className={m.status === "completed" ? "text-white/60 line-through decoration-white/20" : "text-white/80"}>
                    {m.name}
                  </span>
                  <span className="ml-auto text-[10px] font-mono text-white/30">
                    {t(`statuses.${m.status}`)}
                  </span>
                </li>
              ))}
            </ul>

            {p.as_built_url && (
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                data-testid={`download-asbuilt-${p.code}`}
                className="mt-5 inline-flex items-center gap-2 btn-ghost px-3 py-2 text-[11px] font-mono uppercase tracking-[0.18em] rounded-sm"
              >
                <Download className="w-3.5 h-3.5" /> {t("dashboard.asBuilt")}
              </a>
            )}
          </article>
        ))}
      </div>
    </DashboardLayout>
  );
};

export default Projects;
